import { useEffect,useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Trash, Plus, Minus, ShoppingBag } from 'lucide-react';
import { useCart } from '../Context/CartContext';
import { useAuth } from '../auth/AuthContext';
import { getShippingFee } from '../services/userService';
const CartPage = () => {
  const { items, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const [shippingInfo, setShippingInfo] = useState({
    orderMinPay: 0,
    totalAmount: getCartTotal(),
    shippingFee: 0,
  });
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const fetchShippingInfo = async () => {
      const data = await getShippingFee();
      setShippingInfo(data);
    };

    fetchShippingInfo();
  }, []);
  const cartTotal = Number(getCartTotal()); // güvenli dönüşüm
  const shippingFee = Number(shippingInfo.shippingFee); // güvenli dönüşüm
  
  const isFreeShipping = cartTotal >= Number(shippingInfo.orderMinPay);
  
  const finalTotal = isFreeShipping ? cartTotal : cartTotal + shippingFee;
  
  const handleCheckout = () => {
    if (isLoggedIn) {
      navigate('/checkout');
    } else {
      navigate('/login');
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-secondary-light py-12"
    >
      <div className="container-custom">
        <h1 className="text-3xl font-bold text-gray-dark mb-8">Alışveriş Sepeti</h1>
        
        {items.length === 0 ? (
          <div className="bg-white rounded-lg shadow-medium p-8 text-center">
            <div className="flex justify-center mb-4">
              <ShoppingBag size={64} className="text-gray-light" />
            </div>
            <h2 className="text-2xl font-medium text-gray-dark mb-4">Sepetiniz Boş</h2>
            <p className="text-gray mb-6">Sepetinizde ürün bulunmamaktadır.</p>
            <Link 
              to="/" 
              className="btn-primary inline-flex items-center"
            >
              Alışverişe Başla <ArrowRight size={18} className="ml-2" />
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Cart Items */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-lg shadow-medium overflow-hidden">
                {/* Cart header */}
                <div className="p-4 border-b border-gray-200 bg-gray-50">
                  <h2 className="font-medium">Ürünler</h2>
                </div>
                
                {/* Cart items */}
                <ul className="divide-y divide-gray-200">
                  {items.map((item) => (
                    <li key={item.uniqueKey} className="p-4 sm:p-6">
                      <div className="flex flex-col sm:flex-row gap-4">
                        {/* Product image */}
                        <div className="w-full sm:w-24 h-24">
                        <img 
  src={`${process.env.REACT_APP_BASE_URL}${item.product.photo_url}`} 
  alt={item.product.name}
  className="w-full h-full object-contain rounded-md"
/>
                        </div>
                        
                        {/* Product details */}
                        <div className="flex-grow flex flex-col sm:flex-row sm:justify-between gap-4">
                          <div>
                            <h3 className="font-medium text-gray-dark">{item.product.name}</h3>
                             {/* Seçilen Renk ve Beden */}
  {(item.product.color || item.product.size) && (
    <div className="text-sm text-gray mt-1 flex gap-2 flex-wrap">
      {item.product.color && (
        <span>Renk: <span className="font-medium">{item.product.color}</span></span>
      )}
      {item.product.size && (
        <span>Beden: <span className="font-medium">{item.product.size}</span></span>
      )}
    </div>
  )}
                            <p className="text-sm text-gray mt-1">{Number(item.product.price).toFixed(2)} ₺</p>
                          </div>
                          
                          <div className="flex flex-row sm:flex-col justify-between items-end">
                            {/* Quantity */}
                            <div className="flex items-center border border-gray-200 rounded-md">
                              <button 
                                onClick={() => updateQuantity(item.uniqueKey, item.quantity - 1)}
                                className="px-2 py-1 text-gray-dark hover:text-primary transition-colors"
                                aria-label="Decrease quantity"
                              >
                                <Minus size={16} />
                              </button>
                              <span className="px-3 py-1 border-x border-gray-200">{item.quantity}</span>
                              <button 
                                onClick={() => updateQuantity(item.uniqueKey, item.quantity + 1)}
                                className="px-2 py-1 text-gray-dark hover:text-primary transition-colors"
                                aria-label="Increase quantity"
                              >
                                <Plus size={16} />
                              </button>
                            </div>
                            
                            {/* Subtotal */}
                            <div className="flex items-center justify-between mt-2">
                              <span className="font-medium text-gray-dark">
                                {(item.product.price * item.quantity).toFixed(2)} ₺
                              </span>
                              <button 
                                onClick={() => removeFromCart(item.uniqueKey)}
                                className="ml-4 text-red-500 hover:text-red-700 transition-colors"
                                aria-label="Remove from cart"
                              >
                                <Trash size={18} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Order Summary */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-medium p-6 sticky top-20">
                <h2 className="text-xl font-medium text-gray-dark mb-6">Sipariş Özeti</h2>
                
                <div className="space-y-4 mb-6">
                  <div className="flex justify-between">
                    <span className="text-gray">Ara Toplam</span>
                    <span className="text-gray-dark font-medium">{getCartTotal().toFixed(2)} ₺</span>
                  </div>
                  <div className="flex justify-between items-center">
  <span className="text-gray">Kargo</span>
  {getCartTotal() >= shippingInfo.orderMinPay ? (
    <span className="text-green-600 font-medium">Ücretsiz</span>
  ) : (
    <div className="text-right">
      <div className="text-gray-dark font-medium">
        {shippingInfo.shippingFee.toLocaleString()} TL
      </div>
      <div className="text-xs text-gray">
        {`${(shippingInfo.orderMinPay - getCartTotal()).toLocaleString()} TL daha harcayın, kargo ücretsiz olsun`}
      </div>
    </div>
    
  )}
</div>
                  <div className="pt-4 border-t border-gray-200">
                  <div className="flex justify-between">
  <span className="text-lg font-medium text-gray-dark">Toplam</span>
  <span className="text-lg font-semibold text-primary">
    {finalTotal.toFixed(2)} ₺
  </span>
</div>
                  </div>
                </div>
                
                <button 
      onClick={handleCheckout} 
      className="w-full btn-primary flex items-center justify-center"
    >
      Ödemeye Geç <ArrowRight size={18} className="ml-2" />
    </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default CartPage;